import type {
    IPulseTrackerCreateParams,
    Tracker,
    AltEventHandler,
    Builders,
    SDKConfigInput,
} from '@schibsted/pulse-sdk';

const TRACKER_ID = 'svp-tracker';

interface GlobalPulse {
    (cb: (tracker: Tracker) => void): void;
    (
        action: 'init',
        clientId: string,
        config: SDKConfigInput,
        builders?: Builders,
        name?: string,
    ): Promise<void>;
    (action: string, cb: (tracker: Tracker) => void): void;
}

declare global {
    interface Window {
        pulseEventHandler?: AltEventHandler;
        pulse?: GlobalPulse;
    }
}

const trackers: Partial<Record<string, Promise<Tracker | null>>> = {};

const initTracker = async (
    provider: string,
    sdkConfig: IPulseTrackerCreateParams,
) => {
    const storedTracker = await getTracker(provider);

    const PROVIDER_TRACKER_ID = `${TRACKER_ID}-${provider}`;

    // initialize pulse only once per page per provider
    if (!storedTracker) {
        if (!window.pulse) {
            console.warn('Pulse tracker not found');
            return null;
        }
        // we need to name the tracker to avoid tracking conflicts when embedding the player
        window.pulse(
            'init',
            provider,
            {
                altEventHandler: window.pulseEventHandler,
                useBeaconWhenAvailable: true,
                ...sdkConfig,
            },
            undefined,
            PROVIDER_TRACKER_ID,
        );

        trackers[provider] = new Promise((resolve) => {
            window.pulse!(PROVIDER_TRACKER_ID, (tracker) => resolve(tracker));
        });

        return trackers[provider];
    }

    return storedTracker;
};

const getTracker = async (provider: string) => {
    return trackers[provider] || null;
};

export const PulseLoader = {
    getTracker,
    init: initTracker,
    trackers,
};
